import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  getOrganisationDetails,
  updateOrgDetails,
} from "../Dashboard/Services/DashboardServices";
import ImageCropperModal from "../../../Services/Comment/ImageCropperModal";
import { TostMsg } from "../../../App";
function OnBoardingDashboard() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [Isloading, setIsloading] = useState(false);
  const [organizationDetails, setOrganizationDetails] = useState([]);
  const fileInputRef = useRef(null);
  const [acceptRatio, setAcceptRatio] = useState(0);
  const [showCropper, setShowCropper] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [isImageloading, setIsImageloading] = useState(false);
  const toster = useContext(TostMsg);

  useEffect(() => {
    getOrganizationDetails();
  }, [showCropper]);

  const closeIframe = () => {
    document.querySelector("#tutorial .btn-close")?.click();
  };

  async function getOrganizationDetails() {
    const params = {
      OrgId: userDetails?.OrgId,
      LoggedInUserId: userDetails?.Id,
    };
    try {
      setIsloading(true);
      const res = await getOrganisationDetails(params);
      setOrganizationDetails(res?.Data);
      setIsloading(false);
    } catch {
      setIsloading(false);
    }
  }

  const handleClick = () => {
    fileInputRef.current.click(); // Trigger hidden file input
  };
  const handleFileChange = async (event, type) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageSrc(reader.result);
        setShowCropper(true);
        setAcceptRatio(1 / 1);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCropComplete = (croppedBlob) => {
    uploadDocFile([
      new File([croppedBlob], "cropped.jpg", { type: "image/jpeg" }),
    ]);
  };

  async function uploadDocFile(file) {
    setIsImageloading(true);
    if (file) {
      const formData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formData.append("files", file[i]);
      }
      try {  
        const response = await updateOrgDetails(formData);
        const data = await response;
        const ImageURL = data?.Data;
        setIsImageloading(false);
      } catch (error) {
        setIsImageloading(false);
        toster.current.error("Error uploading file:");
      } finally {
      }
    } else {
      setIsImageloading(false);
      toster.current.warn("No file selected");
    }
  }
  return (
    <div>
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-md-10 onboarding-screen">
            <div className="form-head d-flex flex-wrap align-items-center">
              <div className="me-auto top-heading">
                <h1>
                  {organizationDetails[0]?.OrgName}, welcome to OrgCentral
                  <img src="images/org-img/on-boarding/2.png" />
                </h1>
                <p>
                  Your home for all things admin—jump into setup or check out
                  your organization’s controls.
                </p>
              </div>
              <div className="rightside-tabs">
                <Link to="/OrgSetting/Account" className="watch">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-gear me-1"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0" />
                    <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z" />
                  </svg>
                  Organization Settings
                </Link>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="plan-upgrade">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-emoji-smile"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
                      <path d="M4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5z"></path>
                    </svg>
                    <div>
                      <h4>
                        Your Subscription at a Glance<br></br>
                        <b>Subscription:</b>{" "}
                        <span>
                          {" "}
                          {organizationDetails[0]?.SubscriptionName}(Billed
                          Annually)
                        </span>
                      </h4>
                      <b>Seats:</b>{" "}
                      <span>
                        {" "}
                        {organizationDetails[0]?.SubscriptionPlan} Members
                      </span>
                    </div>
                    <div className="action-btnns  text-end">
                      {organizationDetails[0]?.CanUpgrade === 1 && (
                        <Link
                          to="/OrgSetting/Subscription"
                          className="get-start"
                        >
                          Upgrade Plan
                        </Link>
                      )}
                      <Link to="/OrgSetting/Subscription">
                        <a className="dismiss">View Plan - Billing & Plan</a>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="row">
                  <div className="col-xl-9">
                    <div className="remain-option">
                      <h3>Configure your OrgGenie workspace</h3>
                      <div className="progress-div">
                        <div className="progress">
                          <div
                            className="progress-bar"
                            role="progressbar"
                            aria-valuenow={
                              organizationDetails[0]?.ProfileCompletion
                            }
                            aria-valuemin="0"
                            aria-valuemax="100"
                            style={{
                              width: `${
                                organizationDetails[0]?.ProfileCompletion || 0
                              }%`,
                            }}
                          >
                            {organizationDetails[0]?.ProfileCompletion}%
                          </div>
                        </div>
                        <p>
                          {organizationDetails[0]?.ProfileCompletion}% Completed
                        </p>
                      </div>
                      <ul className="timeline">
                        <li className="timeline-inverted">
                          <div className="timeline-badge">1</div>
                          <div className="timeline-panel">
                            <div className="flex-container flex-around">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-person first-svg"
                                viewBox="0 0 16 16"
                              >
                                <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                              </svg>
                              <div className="timeline-heading">
                                <Link to={"/OrgSetting/account"}>
                                  <h4 className="timeline-title">
                                    Complete Your Organization Details
                                  </h4>
                                  <p>
                                    Customize your company info so every
                                    employee feels right at home.
                                  </p>
                                </Link>
                              </div>
                              <div className="status">
                                <Link to={"/OrgSetting/account"}>
                                  <a className="">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-arrow-right second-svg"
                                      viewBox="0 0 16 16"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                                      />
                                    </svg>
                                  </a>
                                </Link>

                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-check2 second-svg"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="timeline-inverted active">
                          <div className="timeline-badge">2</div>
                          <div className="timeline-panel">
                            <div className="flex-container flex-around">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-arrow-clockwise first-svg"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                                ></path>
                                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"></path>
                              </svg>
                              <div className="timeline-heading">
                                <h4 className="timeline-title">
                                  Add Your Company Logo
                                </h4>
                                <p>
                                  Personalized details help your team dive in
                                  faster and with confidence.
                                </p>
                              </div>
                              <div className="status">
                                {showCropper && imageSrc && (
                                  <ImageCropperModal
                                    image={imageSrc}
                                    onCropComplete={handleCropComplete}
                                    onClose={() => setShowCropper(false)}
                                    acceptRatio={acceptRatio}
                                  />
                                )}
                                <label
                                  htmlFor="file-upload"
                                  style={{ cursor: "pointer" }}
                                >
                                  <input
                                    id="file-upload"
                                    type="file"
                                    accept="image/png, image/jpeg, image/jpg"
                                    style={{ display: "none" }}
                                    onChange={(event) =>
                                      handleFileChange(event, 0)
                                    }
                                  />
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    fill="currentColor"
                                    className="bi bi-download second-svg active"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                                  </svg>
                                </label>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="timeline-inverted">
                          <div className="timeline-badge">3</div>
                          <div className="timeline-panel">
                            <div className="flex-container flex-around">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-person-plus first-svg"
                                viewBox="0 0 16 16"
                              >
                                <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                                <path
                                  fillRule="evenodd"
                                  d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5"
                                />
                              </svg>
                              <div className="timeline-heading">
                                <Link to="/UploadEmployee">
                                  <h4 className="timeline-title">
                                    Add Employees
                                  </h4>
                                  <p>
                                    Add team members to OrgGenie to begin using
                                    its features.
                                  </p>
                                </Link>
                              </div>
                              <div className="status">
                                <span>0 Member</span>
                                <Link to="/UploadEmployee">
                                  <a>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-arrow-right second-svg"
                                      viewBox="0 0 16 16"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                                      />
                                    </svg>
                                  </a>
                                </Link>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-check2 second-svg"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="timeline-inverted">
                          <div className="timeline-badge">4</div>
                          <div className="timeline-panel">
                            <div className="flex-container flex-around">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="currentColor"
                                className="bi bi-emoji-smile first-svg"
                                viewBox="0 0 16 16"
                              >
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
                                <path d="M4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5z"></path>
                              </svg>
                              <div className="timeline-heading">
                                <Link
                                  className="has-arrow ai-icon"
                                  aria-expanded="false"
                                  data-toggle="tooltip"
                                  data-placement="right"
                                  data-bs-toggle="modal"
                                  data-bs-target="#check-feedpost"
                                  title="New Post"
                                >
                                  <h4 className="timeline-title">
                                    Create a post
                                  </h4>
                                  <p>
                                    Start your internal engagement by posting
                                    your first update or message.
                                  </p>
                                </Link>
                              </div>
                              <div className="status">
                                <Link
                                  className="has-arrow ai-icon"
                                  aria-expanded="false"
                                  data-toggle="tooltip"
                                  data-placement="right"
                                  data-bs-toggle="modal"
                                  data-bs-target="#check-feedpost"
                                  title="New Post"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-arrow-right second-svg"
                                    viewBox="0 0 16 16"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                                    />
                                  </svg>
                                </Link>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-check2 second-svg"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                                </svg>
                              </div></div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-xl-3">
                    <div className="video-tutorial">
                      <div className="video-container">
                        <div className="js-video ng-isolate-scope">
                          <div className="video-poster"></div>
                          <div
                            className="play"
                            data-bs-toggle="modal"
                            data-bs-target="#tutorial"
                          >
                            <i className="fa fa-play-circle"></i>
                          </div>
                        </div>
                      </div>
                      <div className="">
                        <h6 className="block-heading">How It Works?</h6>
                        <h6>Getting Started: A Quick Demo</h6>
                        <p className="block-text-p">
                          Follow this video to breeze through your initial login
                          and setup steps.
                        </p>
                        <a
                          className="btn fw-semibold"
                          data-bs-toggle="modal"
                          data-bs-target="#tutorial"
                        >
                          Watch tutorials
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row manage-setting-list">
              <div className="col-xl-3">
                <div className="main-add-on-div">
                  <div className="add-on-div">
                    <b> 5</b>
                    <div className="content">
                      <h4>Manage Designations</h4>
                      <div
                        className="status"
                        style={{
                          marginLeft: "83%",
                          marginTop: "-30px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-check2 second-svg"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                        </svg>
                      </div>
                      <p>
                        Define job titles and roles to structure your
                        organization's hierarchy before adding your first
                        employee. Add at least a few — you can always add more
                        later.
                      </p>
                    </div>
                  </div>
                  <Link to="/OrgSetting/Designation">
                    <button>Let's start</button>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3">
                <div className="main-add-on-div">
                  <div className="add-on-div">
                    {" "}
                    <b>6</b>
                    <div className="content">
                      <h4>Make an Announcement</h4>
                      <div
                        className="status"
                        style={{
                          marginLeft: "83%",
                          marginTop: "-30px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-check2 second-svg"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                        </svg>
                      </div>
                      <p>
                        Share important updates company-wide. You may want
                        everyone to know that OrgGenie is now live to simplify
                        Org processes.
                      </p>
                    </div>
                  </div>
                  <Link to="/Announcement/New">
                    <button>Let's start</button>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3">
                <div className="main-add-on-div">
                  <div className="add-on-div">
                    {" "}
                    <b>7</b>
                    <div className="content">
                      <h4>Publish an Article</h4>
                      <div
                        className="status"
                        style={{
                          marginLeft: "83%",
                          marginTop: "-30px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-check2 second-svg"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                        </svg>
                      </div>
                      <p>
                        Post a detailed update, HR communication, or leadership
                        note for all employees.
                      </p>
                    </div>
                  </div>
                  <Link to="/Artical/Add">
                    <button>Let's start</button>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3">
                <div className="main-add-on-div">
                  <div className="add-on-div">
                    {" "}
                    <b>8</b>
                    <div className="content">
                      <h4>Upload Policies</h4>
                      <div
                        className="status"
                        style={{
                          marginLeft: "83%",
                          marginTop: "-30px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-check2 second-svg"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                        </svg>
                      </div>
                      <p>
                        Upload key company policies so employees can access them
                        easily.
                      </p>
                    </div>
                  </div>
                  <Link to="/AddPolicy">
                    <button>Let's start</button>
                  </Link>
                </div>
              </div>

              <div className="col-xl-3">
                <div className="main-add-on-div">
                  <div className="add-on-div">
                    {" "}
                    <b>9</b>
                    <div className="content">
                      <h4>Announce Org Level Holidays</h4>
                      <div
                        className="status"
                        style={{
                          marginLeft: "83%",
                          marginTop: "-30px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-check2 second-svg"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                        </svg>
                      </div>
                      <p>
                        Publish your organization's holiday calendar for
                        visibility across teams.
                      </p>
                    </div>
                  </div>
                  <Link to="/OrganizationLeave">
                    <button>Let's start</button>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3">
                <div className="main-add-on-div">
                  <div className="add-on-div">
                    {" "}
                    <b> 10</b>
                    <div className="content">
                      <h4>Upload Couple of Pictures</h4>
                      <div
                        className="status"
                        style={{
                          marginLeft: "83%",
                          marginTop: "-30px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-check2 second-svg"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                        </svg>
                      </div>
                      <p>
                        Add workplace photos to personalize everyone's
                        dashboard.
                      </p>
                    </div>
                  </div>
                  <Link to="/CreateAlbum">
                    <button>Let's start</button>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3">
                <div className="main-add-on-div">
                  <div className="add-on-div">
                    {" "}
                    <b>11</b>
                    <div className="content">
                      <h4>Add Ticket Categories</h4>
                      <div
                        className="status"
                        style={{
                          marginLeft: "83%",
                          marginTop: "-30px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-check2 second-svg"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                        </svg>
                      </div>
                      <p>
                        Define service request categories like HR, IT, and
                        Admin.
                      </p>
                    </div>
                  </div>
                  <Link to="/OrgSetting/RequestCategory">
                    <button>Let's start</button>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3">
                <div className="main-add-on-div">
                  <div className="add-on-div">
                    {" "}
                    <b>12</b>
                    <div className="content">
                      <h4>Add Ticket Sub Categories</h4>
                      <div
                        className="status"
                        style={{
                          marginLeft: "83%",
                          marginTop: "-30px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-check2 second-svg"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                        </svg>
                      </div>
                      <p>
                        Create subcategories under each ticket type for better
                        request resolution.
                      </p>
                    </div>
                  </div>
                  <Link to="/OrgSetting/RequestSubCategory">
                    <button>Let's start</button>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3">
                <div className="main-add-on-div">
                  <div className="add-on-div">
                    {" "}
                    <b>13</b>
                    <div className="content">
                      <h4>Configure Leave Types</h4>
                      <div
                        className="status"
                        style={{
                          marginLeft: "83%",
                          marginTop: "-30px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-check2 second-svg"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                        </svg>
                      </div>
                      <p>
                        Set up your organization’s leave types like Casual,
                        Sick, or Paid Leave.
                      </p>
                    </div>
                  </div>
                  <Link to="/OrgSetting/LeaveTypes">
                    <button>Let's start</button>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3">
                <div className="main-add-on-div">
                  <div className="add-on-div">
                    {" "}
                    <b>14</b>
                    <div className="content">
                      <h4>Configure Work From Home</h4>
                      <div
                        className="status"
                        style={{
                          marginLeft: "83%",
                          marginTop: "-30px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-check2 second-svg"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                        </svg>
                      </div>
                      <p>Enable and define your WFH policy & quota.</p>
                    </div>
                  </div>
                  <Link to="/OrgSetting/WFHType">
                    <button>Let's start</button>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3">
                <div className="main-add-on-div">
                  <div className="add-on-div">
                    {" "}
                    <b>15</b>
                    <div className="content">
                      <h4>Manage Organization Branches</h4>
                      <div
                        className="status"
                        style={{
                          marginLeft: "83%",
                          marginTop: "-30px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-check2 second-svg"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                        </svg>
                      </div>
                      <p>
                        Add all your office locations or branches to map your
                        workforce.
                      </p>
                    </div>
                  </div>
                  <Link to="/OrgSetting/LocationType">
                    <button>Let's start</button>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3">
                <div className="main-add-on-div">
                  <div className="add-on-div">
                    {" "}
                    <b>16</b>
                    <div className="content">
                      <h4>Manage Departments</h4>
                      <div
                        className="status"
                        style={{
                          marginLeft: "83%",
                          marginTop: "-30px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-check2 second-svg"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                        </svg>
                      </div>
                      <p>
                        Create departments to group employees by functions and
                        reporting lines.
                      </p>
                    </div>
                  </div>
                  <Link to="/OrgSetting/Departments">
                    <button>Let's start</button>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3">
                <div className="main-add-on-div">
                  <div className="add-on-div">
                    {" "}
                    <b>17</b>
                    <div className="content">
                      <h4>Manage Employee Bands</h4>
                      <div
                        className="status"
                        style={{
                          marginLeft: "83%",
                          marginTop: "-30px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-check2 second-svg"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                        </svg>
                      </div>
                      <p>
                        Define employee bands to organize roles by levels or
                        seniority.
                      </p>
                    </div>
                  </div>
                  <Link to="/AddPolicy">
                    <button>Let's start</button>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3">
                <div className="main-add-on-div">
                  <div className="add-on-div">
                    {" "}
                    <b>18</b>
                    <div className="content">
                      <h4>Manage Employee Grades</h4>
                      <div
                        className="status"
                        style={{
                          marginLeft: "83%",
                          marginTop: "-30px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-check2 second-svg"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                        </svg>
                      </div>
                      <p>
                        Set up grades for employees to structure compensation &
                        other facilities.
                      </p>
                    </div>
                  </div>
                  <Link to="/AddPolicy">
                    <button>Let's start</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="tutorial">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-body p-0">
              <button
                type="button"
                className="btn-close"
                onclick={closeIframe}
                data-bs-dismiss="modal"
                style={{ top: "10px", right: "10px", zIndex: 1000 }}
              >
                ×
              </button>
              <iframe
                width="100%"
                height="450"
                src="https://www.youtube.com/embed/q1YPfKl3_6g?si=Fa5cSES3xfwV8M0b"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default OnBoardingDashboard;
